import { APIServiceType } from '@/api/types';
import { CustomError } from '@/utilities/errors/CustomError';
import { handleError } from '@/utilities/errors/handleError';
import { APIError, ErrorType } from '@/utilities/errors/types';

/**
 * Mirrors the API error path from the legacy `ApiRequestWrapper` catch block.
 */
export const reportQueryApiError = (
  err: unknown,
  service: APIServiceType,
): void => {
  const error =
    err instanceof CustomError
      ? err
      : new CustomError(
          err instanceof Error ? err.message : 'Unknown API error',
          {
            type: ErrorType.API,
            reason: 'Request failed',
            service,
            stack: err instanceof Error ? err.stack : undefined,
          },
        );

  handleError<APIError>(
    {
      type: ErrorType.API,
      payload: {
        name: error.message,
        message: error.message,
        reason: error.meta?.reason ?? 'Request failed',
        service: error.meta?.service ?? service,
      },
    },
    {
      context: error.meta?.context,
      eventType: error.meta?.eventType,
      service: error.meta?.service ?? service,
      stack: error.meta?.stack ?? error.stack,
      useCase: error.meta?.useCase,
    },
  );
};
